import { render, staticRenderFns } from "./screenfull.vue?vue&type=template&id=647b4bb4&scoped=true&"
import script from "./screenfull.vue?vue&type=script&lang=js&"
export * from "./screenfull.vue?vue&type=script&lang=js&"
import style0 from "./screenfull.vue?vue&type=style&index=0&id=647b4bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b4bb4",
  null
  
)

export default component.exports